import React from 'react';
import styled from 'styled-components';
import Required from '../../atoms/Required';

export const Row = styled.div`
  display: flex;
  margin: 5px 0;
  padding: 5px;
  border-bottom: 1px solid #eee;
`;

export const RowHeader = styled.div`
  font-weight: 600;
  width: 25%;
`;

export const RowCell = styled.div`
  width: 75%;
`;

export const OAuthClientHeaders = ({ keyName }) => {
  const headers = {
    private_money: (
      <RowHeader>
        マネー <Required />
      </RowHeader>
    ),
    organization: (
      <RowHeader>
        組織 <Required />
      </RowHeader>
    ),
    id: <RowHeader>OAuthClient ID</RowHeader>,
    name: (
      <RowHeader>
        OAuthClient名 <Required />
      </RowHeader>
    ),
    client_secret: <RowHeader>Client Secret</RowHeader>,
    redirect_uri: (
      <RowHeader>
        リダイレクトURI <Required />
      </RowHeader>
    ),
    allowed_grant_types: <RowHeader>許可種別</RowHeader>,
    default_scopes: <RowHeader>デフォルトスコープ</RowHeader>,
    default_private_money: <RowHeader>デフォルトマネー</RowHeader>,
    creating_account_type: <RowHeader>作成するアカウントタイプ</RowHeader>,
    description: <RowHeader>説明</RowHeader>,
    oauth_client_image: <RowHeader>画像</RowHeader>,
    conceal_user_existence: <RowHeader>ユーザー存在可否の通知</RowHeader>
  };
  return headers[keyName];
};

export default OAuthClientHeaders;
